import React from "react";
import { observer } from "mobx-react-lite";
import { buildBuyerRemarks } from "@/utils/OrderUtils";
import OrderDTO from "@/dto/order/OrderDTO";

interface BuyerRemarksProps {
    order: OrderDTO;
}

const BuyerRemarks: React.FC<BuyerRemarksProps> = observer(function (props) {
    const { order } = props;

    if (!order.buyerRemarks) {
        return null;
    }

    const buyerRemarksContent = buildBuyerRemarks(order);

    if (!buyerRemarksContent) {
        return null;
    }

    return <p className="buyer-remarks">买家：{buyerRemarksContent}</p>;
});

export default BuyerRemarks;
